import { ResponsiveModalWrapper } from 'src/components/ResponsiveModalWrapper';
import { Content } from './components/Content';
import { Buttons } from './components/Buttons';

export const ConfirmBonusModal = () => {
  return (
    <ResponsiveModalWrapper
      containerClassName="pb-7 min-h-[240px] w-[400px]"
      containerClassNameMobile="pb-8 min-h-[320px] flex flex-col justify-between rounded-b-none"
      showCross={false}>
      <Content />
      <Buttons />
    </ResponsiveModalWrapper>
  );
};
